import React from 'react';
import { useEffect } from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import InOutResultContext from '../../services/inOutResult/InOutResultContext';

import { Confirmation, Information } from '../modals/common/';
import { SelectHour } from '../select/SelectHour';
import { SelectMin } from '../select/SelectMin';
import { OnOffRadioButton } from '../radiobutton/OnOffRadioButton';
import { SearchMenuHeader } from '../searchmenus/SearchMenuHeader';
import { TextBox } from '../textbox/TextBox';
import { SelectBox } from '../select/SelectBox';
import { FieldTreeCompanyDropdown } from '../dropdowns/single/FieldTreeCompanyDropdown';
import RequireIcon from '../../components/RequireIcon';
import InOutResultDropdownSelector from '../../components/dropdowns/single/InOutResult';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import FieldSpotWorkersApi from '../../services/fieldSpotWorkers/FieldSpotWorkersApi';

import { isPartnerCompanyRoleId } from '../../utilities/roleUtility';
import { messageUtility } from '../../utilities/messageUtility';
import {
  isNullOrEmpty,
  isNullOrUndefinedOrEmptyStr,
} from '../../utilities/stringUtil';
import {
  DATE_TIME_FORMAT,
  DIALOG_STATUS,
  RECORDING_METHOD,
  CCUS_SENT_STATUS,
  MANUAL_BODY_TEMPERATURE,
  ENTRANCE_WORKER_TYPES,
} from '../../utilities/constants';

import Styles from '../../styles/componentStyle/inOutResult/inOutResult.scss';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';

/**
 * 入退場実績ヘッダー (追加、削除、全承認、承認、承認解除、表示データをCSV出力)
 */
export class OperationHeader extends React.Component {
  // 画面表示
  render() {
    return (
      <InOutResultContext.Consumer>
        {({
          state,
          showAddDialog,
          showDeleteDialogIfValid,
          showApproveAllDialog,
          showApproveDialogIfValid,
          showUnapprovedDialogIfValid,
          downloadCheckInOutCsv,
          closeEditDialog,
          closeDialog,
          closeErrorDialog,
          deleteCheckInOutResultList,
          approveAllCheckInOutResult,
          approveCheckInOutResultList,
          unApprovedCheckInOutResultList,
          closeWorkerSelectDialog,
          registerCheckInOutResult,
        }) => (
          <div
            className={`${Styles.operationHeader} gate-schedulelist__header`}
          >
            <ul className='btn-menu'>
              <li className='btn-menu__item'>
                <button className='btn' onClick={() => showAddDialog()}>
                  {data.buttonTitle.add}
                </button>
              </li>
              {!isPartnerCompanyRoleId(state.roleId) && (
                <React.Fragment>
                  <li className='btn-menu__item'>
                    <button
                      className='btn--negative'
                      onClick={() => showDeleteDialogIfValid()}
                    >
                      {data.buttonTitle.delete}
                    </button>
                  </li>
                  <li className='left-separator btn-menu__item'>
                    <button
                      className='btn--effective'
                      onClick={() => showApproveAllDialog()}
                    >
                      {data.buttonTitle.approveAll}
                    </button>
                  </li>
                  <li className='btn-menu__item'>
                    <button
                      className='btn--effective'
                      onClick={() => showApproveDialogIfValid()}
                    >
                      {data.buttonTitle.approve}
                    </button>
                  </li>
                  <li className='btn-menu__item'>
                    <button
                      className='btn--negative'
                      onClick={() => showUnapprovedDialogIfValid()}
                    >
                      {data.buttonTitle.unapproved}
                    </button>
                  </li>
                </React.Fragment>
              )}
              <li className='left-separator btn-menu__item'>
                <button
                  className='btn--sub'
                  onClick={() => downloadCheckInOutCsv()}
                >
                  {data.buttonTitle.downloadCsv}
                </button>
              </li>
            </ul>

            <Confirmation
              visible={
                state.dialogStatus === DIALOG_STATUS.registerDialogEnabled.id
              }
              title={messageUtility.getMessage('I-002-006-10')}
              confirmButtonText={data.buttonTitle.add}
              cancelButtonText={data.buttonTitle.back}
              message={<AddDialogMessage />}
              isNegative={true}
              onCancel={() => closeEditDialog()}
              onConfirm={() => registerCheckInOutResult()}
              disabledConfirmButton={
                (isNullOrEmpty(state.editForm.fieldTreeWorkerId) &&
                  isNullOrEmpty(state.editForm.workerId)) ||
                state.editForm.isValid !== true
              }
              rootClassName={Styles.editDialog}
              negativeButtonClassName={
                (isNullOrEmpty(state.editForm.fieldTreeWorkerId) &&
                  isNullOrEmpty(state.editForm.workerId)) ||
                state.editForm.isValid !== true
                  ? 'btn-disable'
                  : 'btn'
              }
            />

            <Confirmation
              visible={
                state.dialogStatus === DIALOG_STATUS.deleteDialogEnabled.id
              }
              title={messageUtility.getMessage('I-002-006-05')}
              confirmButtonText={data.buttonTitle.delete}
              cancelButtonText={data.buttonTitle.back}
              message={<DialogMessage />}
              isNegative={true}
              onCancel={() => closeDialog()}
              onConfirm={() => deleteCheckInOutResultList()}
              rootClassName={Styles.dialog}
              negativeButtonClassName='btn--negative'
            />

            <Confirmation
              visible={
                state.dialogStatus === DIALOG_STATUS.approveAllDialogEnabled.id
              }
              title={messageUtility.getMessage('I-002-006-08')}
              confirmButtonText={data.buttonTitle.approveAll}
              cancelButtonText={data.buttonTitle.back}
              message={messageUtility.getMessage('I-002-006-09')}
              isNegative={true}
              onCancel={() => closeDialog()}
              onConfirm={() => approveAllCheckInOutResult()}
              negativeButtonClassName='btn'
            />

            <Confirmation
              visible={
                state.dialogStatus === DIALOG_STATUS.approvedDialogEnabled.id
              }
              title={messageUtility.getMessage('I-002-006-01')}
              confirmButtonText={data.buttonTitle.approve}
              cancelButtonText={data.buttonTitle.back}
              message={<DialogMessage />}
              isNegative={true}
              onCancel={() => closeDialog()}
              onConfirm={() => approveCheckInOutResultList()}
              rootClassName={`${Styles.dialog} ${Styles.approveConfirm}`}
              negativeButtonClassName='btn'
            />

            <Confirmation
              visible={
                state.dialogStatus === DIALOG_STATUS.unapprovedDialogEnabled.id
              }
              title={messageUtility.getMessage('I-002-006-03')}
              confirmButtonText={data.buttonTitle.unapproved}
              cancelButtonText={data.buttonTitle.back}
              message={<DialogMessage />}
              isNegative={true}
              onCancel={() => closeDialog()}
              onConfirm={() => unApprovedCheckInOutResultList()}
              rootClassName={`${Styles.dialog} ${Styles.approveConfirm}`}
              negativeButtonClassName='btn--negative'
            />

            <Information
              visible={
                state.dialogStatus === DIALOG_STATUS.isWorkerSelectDialogShow.id
              }
              title={messageUtility.getMessage('I-002-006-14')}
              buttonText={data.buttonTitle.close}
              message={<WorkerSelectDialog />}
              isNegative={true}
              onClose={() => closeWorkerSelectDialog()}
              rootClassName={Styles.workerSelectDialog}
            />

            <Information
              visible={
                state.dialogStatus ===
                DIALOG_STATUS.isFieldTreeSelectDialogShow.id
              }
              title={messageUtility.getMessage('I-002-006-15')}
              buttonText={data.buttonTitle.close}
              message={<FieldTreeSelectDialog />}
              isNegative={true}
              onClose={() => closeWorkerSelectDialog()}
              rootClassName={Styles.fieldTreeSelectDialog}
            />

            <Information
              rootClassName={
                state.failDialog.message && state.failDialog.message.length > 28
                  ? 'wide-dialog-md'
                  : ''
              }
              visible={
                state.dialogStatus ===
                  DIALOG_STATUS.deleteFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.approveAllFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.approveFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.unapprovedFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.uploadFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.deleteErrorDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.updateErrorDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.cancelApproveFailDialogEnabled.id
              }
              title={state.failDialog.title}
              message={state.failDialog.message}
              buttonText={data.buttonTitle.back}
              onClose={() => closeDialog()}
              multilineText={
                state.dialogStatus ===
                  DIALOG_STATUS.deleteFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.approveFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.unapprovedFailDialogEnabled.id ||
                state.dialogStatus ===
                  DIALOG_STATUS.approveAllFailDialogEnabled.id
              }
            />

            <Information
              visible={
                state.errorDialogStatus ===
                  DIALOG_STATUS.networkErrorDialogEnabled.id ||
                state.errorDialogStatus ===
                  DIALOG_STATUS.selectWorkerFailDialogEnabled.id
              }
              message={state.failDialog.message}
              buttonText={data.buttonTitle.back}
              onClose={() => closeErrorDialog()}
            />

            <Information
              visible={
                state.errorDialogStatus ===
                DIALOG_STATUS.downloadInOutResultCsvFailDialogEnabled.id
              }
              message={state.failDialog.message}
              buttonText={data.buttonTitle.back}
              onClose={() => closeErrorDialog()}
              multilineText={true}
            />
          </div>
        )}
      </InOutResultContext.Consumer>
    );
  }
}

/**
 * 入退場実績追加ダイアログメッセージ
 * */
const AddDialogMessage = () => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({
        state,
        showSelectWorkerDialog,
        toggle,
        setTime,
        setManualBodyTemperature,
        setRemarks,
        onChangeWorkerType,
        selectedWorker,
      }) => (
        <ul className='form-list form-list-default'>
          {state.spotFlg && (
            <li className='form-list__item'>
              <div className='worker-type__label'>
                <span className='label'>
                  {data.addDialog.workerType}
                  <RequireIcon />
                </span>
              </div>
              <div className='worker-type__element'>
                <div className='form-list-radio'>
                  <div className='form-list-radio__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='worker_type'
                        value={ENTRANCE_WORKER_TYPES.worker.id}
                        checked={
                          parseInt(state.editForm.workerType) ===
                          ENTRANCE_WORKER_TYPES.worker.id
                        }
                        onChange={event =>
                          onChangeWorkerType(event.target.value)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{ENTRANCE_WORKER_TYPES.worker.name}</span>
                    </label>
                  </div>
                  <div className='form-list-radio__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='worker_type'
                        value={ENTRANCE_WORKER_TYPES.permanent.id}
                        checked={
                          parseInt(state.editForm.workerType) ===
                          ENTRANCE_WORKER_TYPES.permanent.id
                        }
                        onChange={event =>
                          onChangeWorkerType(event.target.value)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>現場{ENTRANCE_WORKER_TYPES.permanent.name}</span>
                    </label>
                  </div>
                  <div className='form-list-radio__item'>
                    <label className='radio'>
                      <input
                        type='radio'
                        name='worker_type'
                        value={ENTRANCE_WORKER_TYPES.guest.id}
                        checked={
                          parseInt(state.editForm.workerType) ===
                            ENTRANCE_WORKER_TYPES.temporary.id ||
                          parseInt(state.editForm.workerType) ===
                            ENTRANCE_WORKER_TYPES.guest.id
                        }
                        onChange={event =>
                          onChangeWorkerType(event.target.value)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>
                        {ENTRANCE_WORKER_TYPES.temporary.name}・
                        {ENTRANCE_WORKER_TYPES.guest.name}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </li>
          )}
          <li className='form-list__item'>
            <div className='worker-name__label'>
              <span className='label'>{data.addDialog.workerName}</span>
            </div>
            <div className='worker-name__element'>
              {(state.editForm.workerType ===
                ENTRANCE_WORKER_TYPES.worker.id && (
                <React.Fragment>
                  <span>{state.editForm.workerName}</span>
                  <button
                    className='btn--sub'
                    onClick={() => showSelectWorkerDialog()}
                  >
                    {data.buttonTitle.worker_search}
                  </button>
                </React.Fragment>
              )) || (
                <InOutResultDropdownSelector
                  hasTooltipAllSelect={false}
                  multiple={false}
                  api={params =>
                    FieldSpotWorkersApi.fetchFieldSpotWorkersList(
                      SessionStorageService.getFieldId(),
                      params
                    )
                  }
                  clearFlag={state.editFormClearFlag}
                  apiParams={state.apiData}
                  apiSearchKey='spot_worker_name'
                  keyName='fullname'
                  valueName='entrance_worker_id'
                  label='選択してください'
                  selectedValues={state.editForm.workerId}
                  apiProcess={response => {
                    if (_.isNil(response.data.entities)) {
                      return {
                        data: [],
                        total: 0,
                      };
                    }
                    const list = _.map(
                      response.data.entities.field_spot_workers,
                      item => ({
                        entrance_worker_id: item.entrance_worker_id,
                        fullname: item.fullname,
                        spot_company_name: item.spot_company_name,
                        prime_company_name: item.prime_company_name,
                      })
                    );
                    return {
                      data: list,
                      total: list.length,
                    };
                  }}
                  onSelect={values => {
                    selectedWorker(values);
                  }}
                />
              )}
            </div>
          </li>
          {[
            ENTRANCE_WORKER_TYPES.temporary.id,
            ENTRANCE_WORKER_TYPES.guest.id,
          ].includes(state.editForm.workerType) &&
            (state.editForm.spotCompanyName ||
              state.editForm.primeCompanyName) && (
              <React.Fragment>
                <li className='form-list__item'>
                  <div className='field-tree__label'>
                    <span className='label'>{data.addDialog.companyName}</span>
                  </div>
                  <div className='field-tree__element'>
                    <p>
                      {(state.editForm.workerType ===
                        ENTRANCE_WORKER_TYPES.guest.id &&
                        state.editForm.spotCompanyName) ||
                        state.editForm.primeCompanyName}
                    </p>
                  </div>
                </li>
              </React.Fragment>
            )}
          {state.editForm.workerType === ENTRANCE_WORKER_TYPES.worker.id && (
            <li className='form-list__item'>
              <div className='field-tree__label'>
                <span className='label'>{data.addDialog.fieldTree}</span>
              </div>
              <div className='field-tree__element'>
                <p>{state.editForm.displayFieldTree}</p>
              </div>
            </li>
          )}
          {state.editForm.recordingMethod !== '' && (
            <React.Fragment>
              <li className='form-list__item'>
                <OnOffRadioButton
                  label={data.addDialog.recordingMethod}
                  name='recording_method'
                  onButtonLabel={RECORDING_METHOD.entranceAndExit.name}
                  offButtonLabel={RECORDING_METHOD.onlyAdmission.name}
                  value={state.editForm.recordingMethod}
                  rootClassName='recording-method'
                  onChange={() => toggle('recordingMethod')}
                />
              </li>
            </React.Fragment>
          )}
          <li className='form-list__item'>
            <div className='attendance-date__label'>
              <span className='label'>{data.addDialog.attendanceDate}</span>
            </div>
            <div className='attendance-date__element'>
              <div className='sys-form-calender'>
                <div className='dropdown-calender'>
                  <div className='dropdown-calender__input'>
                    <input
                      className='sys-dropdown-trigger sys-name sys-dropdown-trigger--inner-dialog'
                      type='text'
                      name='editForm.targetDate'
                      placeholder={data.placeholder.attendanceDate}
                      value={state.editForm.targetDate}
                      onChange={() => null}
                      autoComplete='off'
                      readOnly
                    />
                    <div className='btn-spin'>
                      <button className='btn-spin__up sys-calender-day-up'>
                        <i className='i_arrow-top' />
                      </button>
                      <button className='btn-spin__down sys-calender-day-down'>
                        <i className='i_arrow-bottom' />
                      </button>
                    </div>
                  </div>
                  <div className='dropdown'>
                    <div className='dropdown-calender__calender' />
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li className='form-list__item'>
            <div className='in-time__label'>
              <span className='label'>{data.addDialog.inTime}</span>
            </div>
            <div className='in-time__element'>
              <SelectHour
                className='in_hour'
                name='in_hour'
                value={state.editForm.inHour}
                onChange={event => setTime('inHour', event.target.value)}
              />
              <span className='dialog__colon'>{data.dateColon}</span>
              <SelectMin
                className='in_min'
                name='in_min'
                value={state.editForm.inMin}
                onChange={event => setTime('inMin', event.target.value)}
              />
            </div>
          </li>
          {state.editForm.recordingMethod ===
            RECORDING_METHOD.entranceAndExit.id && (
            <React.Fragment>
              <li className='form-list__item'>
                <div className='out-time__label'>
                  <span className='label'>{data.addDialog.outTime}</span>
                </div>
                <div className='out-time__element'>
                  <SelectHour
                    className='out_hour'
                    name='out_hour'
                    value={state.editForm.outHour}
                    onChange={event => setTime('outHour', event.target.value)}
                  />
                  <span className='dialog__colon'>{data.dateColon}</span>
                  <SelectMin
                    className='out_min'
                    name='out_min'
                    value={state.editForm.outMin}
                    onChange={event => setTime('outMin', event.target.value)}
                  />
                </div>
              </li>
              <li className='form-list__item'>
                <div className='next-day__label'>
                  <span className='label'>{data.addDialog.nextDay}</span>
                </div>
                <div className='next-day__element'>
                  <label className='toggle-radius'>
                    <input
                      type='checkbox'
                      checked={state.editForm.nextFlg}
                      onChange={() => {
                        toggle('nextFlg');
                      }}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                  </label>
                </div>
              </li>
            </React.Fragment>
          )}
          <li className='form-list__item'>
            <div className='manual-body-temperature__label'>
              <span className='label'>
                {data.addDialog.manualBodyTemperature}
              </span>
            </div>
            <div className='manual-body-temperature__element'>
              <SelectBox
                name='manual-body-temperature'
                value={state.editForm.manualBodyTemperature}
                isPlaceholderHidden={true}
                items={MANUAL_BODY_TEMPERATURE}
                onChange={event => {
                  setManualBodyTemperature(event.target.value);
                }}
              />
            </div>
          </li>
          <li className='form-list__item'>
            <div className='remarks__label'>
              <span className='label'>{data.addDialog.remarks}</span>
            </div>
            <div className='remarks__element'>
              <div
                className={`wrapper ${
                  state.editForm.errorList.remarks ? 'has-error' : ''
                }`}
              >
                <textarea
                  name='content'
                  className='textarea'
                  maxLength={30}
                  value={state.editForm.remarks}
                  onChange={e => setRemarks(e.target.value)}
                />
                {state.editForm.errorList.remarks && (
                  <div className='error-message'>
                    {state.editForm.errorList.remarks}
                  </div>
                )}
              </div>
            </div>
          </li>
          {state.editForm.workerType === ENTRANCE_WORKER_TYPES.worker.id && (
            <React.Fragment>
              <li className='form-list__item'>
                <div className='job-category__label'>
                  <span className='label'>{data.addDialog.jobCategory}</span>
                </div>
                <div className='job-category__element'>
                  {isNullOrUndefinedOrEmptyStr(
                    state.editForm.categoryMajorName
                  ) === false &&
                    isNullOrUndefinedOrEmptyStr(
                      state.editForm.categoryMinorName
                    ) === false && (
                      <React.Fragment>
                        {state.editForm.categoryMajorName}
                        <span className='hyphen'>-</span>
                        {state.editForm.categoryMinorName}
                      </React.Fragment>
                    )}
                </div>
              </li>
              <li className='form-list__item'>
                <div className='position__label'>
                  <span className='label'>{data.addDialog.position}</span>
                </div>
                <div className='position__element'>
                  {state.editForm.positionName}
                </div>
              </li>
              <li className='form-list__item'>
                <div className='work-content__label'>
                  <span className='label'>{data.addDialog.workContent}</span>
                </div>
                <div className='work-content__element'>
                  <span>{state.editForm.workContent}</span>
                </div>
              </li>
            </React.Fragment>
          )}
        </ul>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 作業員一覧ダイアログ
 * */
const WorkerSelectDialog = () => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({
        state,
        selectFieldTree,
        changeWorkerName,
        searchWorkerList,
        clearWorkerSelectSearchData,
      }) => (
        <div className='master-slide-view__body'>
          <div className='search-form'>
            <SearchMenuHeader
              total={state.workerSelectDialog.total}
              isOpened={true}
              clearSearchProperty={() => {
                clearWorkerSelectSearchData();
              }}
            />
            <div className='search-form__body'>
              <div className='form form--search-form'>
                <div className='form__group flex-wrap'>
                  <div className='search-form-element search-form-element--truncate'>
                    <TextBox
                      label={data.searchTitle.workerName}
                      placeholder={data.placeholder.workerName}
                      value={state.workerSelectDialog.searchForm.workerName}
                      onInput={event => {
                        changeWorkerName(event);
                      }}
                    />
                  </div>
                  <div className='search-form-element search-form-element--truncate'>
                    <div className='select-box__label'>
                      <span className='label'>
                        {data.searchTitle.companyName}
                      </span>
                    </div>
                    <div className='select-box__element set-width-dropdown'>
                      <FieldTreeCompanyDropdown
                        value={state.workerSelectDialog.searchForm.fieldTreeIds}
                        onSelect={values => {
                          selectFieldTree(values);
                        }}
                        searchBoxClearFlag={
                          state.workerSelectDialog.searchBoxClearFlag
                        }
                      />
                    </div>
                  </div>
                  <div className='search-form-element'>
                    <div className='button__element'>
                      <button
                        className='btn--sm--stay'
                        onClick={() => searchWorkerList()}
                      >
                        {data.buttonTitle.search}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='scroll-container'>
            <table className='table'>
              <thead className='table__header'>
                <tr className='table__label'>
                  {_.map(data.workerSelectTableTitles, (title, index) => (
                    <th
                      className='value-table value-table--table__label'
                      key={index}
                    >
                      <div className='value-table__label'> {title} </div>
                    </th>
                  ))}
                </tr>
              </thead>
              {state.workerSelectDialog.total > 0 ? (
                <tbody className='table__body'>
                  {_.map(state.workerList, (worker, index) => {
                    return <WorkerItem worker={worker} key={index} />;
                  })}
                </tbody>
              ) : (
                <tbody className='table__body'>
                  <tr>
                    <td colSpan='4'>
                      <p className='description'>
                        {state.workerSelectDialog.listMessage}
                      </p>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 作業員情報を表示
 * */
const WorkerItem = ({ worker }) => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({ selectWorker }) => (
        <tr className='table__item' onClick={() => selectWorker(worker)}>
          <td className='gate-list-value-table__name'>
            <div className='wrapper-content'>
              <p>{`${worker.name_sei} ${worker.name_mei}`}</p>
            </div>
          </td>
          <td className='gate-list-value-table__name'>
            <div className='wrapper-content'>
              <p>{worker.company_name}</p>
            </div>
          </td>
          <td className='gate-list-value-table__name'>
            <div className='wrapper-content'>
              <p>{worker.birthday}</p>
            </div>
          </td>
          <td className='gate-list-value-table__name'>
            <div className='wrapper-content'>
              <p>{worker.ccus_engineer_id}</p>
            </div>
          </td>
        </tr>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 施工体系選択ダイアログ
 * */
const FieldTreeSelectDialog = () => {
  useEffect(() => {
    const measureHeight = () => {
      const infoDiv = document.querySelector('.info');
      if (infoDiv) {
        const infoHeight = infoDiv.getBoundingClientRect().height;
        document.documentElement.style.setProperty(
          '--info-height',
          `${160 + infoHeight}px`
        );
      }
    };

    measureHeight();

    window.addEventListener('resize', measureHeight);

    return () => {
      window.removeEventListener('resize', measureHeight);
    };
  }, []);
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({ state, backWorkerSelectDialog }) => (
        <div className='master-slide-view__body'>
          <div className='info'>
            <div className='info__back'>
              <button
                className={'btn-text--sm'}
                onClick={() => backWorkerSelectDialog()}
              >
                {data.buttonTitle.backWorkerSelect}
              </button>
            </div>
            <div className='info__content'>
              <div className='info__worker-name'>
                <span>
                  {`${data.addDialog.workerName} : ${state.workerSelectDialog.selectWorkerName}`}
                </span>
              </div>
              <div className='info__message'>
                <span>{messageUtility.getMessage('I-002-006-16')}</span>
              </div>
            </div>
          </div>
          <div className='scroll-container'>
            <table className='table'>
              <thead className='table__header'>
                <tr className='table__label'>
                  {_.map(data.fieldTreeSelectTableTitles, (title, index) => (
                    <th
                      className='value-table value-table--table__label'
                      key={index}
                    >
                      <div className='value-table__label'> {title} </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className='table__body'>
                {_.map(state.fieldTreeList, (fieldTree, index) => {
                  return (
                    <FieldTreeItem
                      fieldTree={fieldTree}
                      workerName={state.editForm.workerName}
                      key={index}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 施工体系情報を表示
 * */
const FieldTreeItem = ({ fieldTree, workerName }) => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({ changeWorker, displayFieldTreeRoute }) => (
        <tr
          className='table__item'
          onClick={() => changeWorker(fieldTree, workerName)}
        >
          <td className='gate-list-value-table__name'>
            <p>{fieldTree.company_name}</p>
          </td>
          <td className='gate-list-value-table__name'>
            <p>{displayFieldTreeRoute(fieldTree)}</p>
          </td>
        </tr>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 承認・承認解除・削除ダイアログメッセージ
 * */
const DialogMessage = () => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({ state }) => (
        <div className={`${Styles.table} master-slide-view__body`}>
          {state.dialogStatus === DIALOG_STATUS.deleteDialogEnabled.id && (
            <React.Fragment>
              <p className='description'>
                {messageUtility.getMessage('I-002-006-06')}
              </p>
              {!_.isEmpty(
                _.filter(
                  _.unionWith(
                    state.selectedApproveCheckInOutLogList,
                    state.selectedUnapprovedCheckInOutLogList,
                    _.isEqual
                  ),
                  function(inOutResult) {
                    return (
                      inOutResult.ccus_send_status !==
                      CCUS_SENT_STATUS.unsent.id
                    );
                  }
                )
              ) && (
                <p className='description'>
                  {messageUtility.getMessage('I-002-006-07')}
                </p>
              )}
            </React.Fragment>
          )}
          {state.dialogStatus === DIALOG_STATUS.approvedDialogEnabled.id && (
            <p className='description'>
              {messageUtility.getMessage('I-002-006-02')}
            </p>
          )}
          {state.dialogStatus === DIALOG_STATUS.unapprovedDialogEnabled.id && (
            <p className='description'>
              {messageUtility.getMessage('I-002-006-04')}
            </p>
          )}
          <table className='table'>
            <thead className='table__header'>
              <tr className='table__label'>
                {_.map(data.tableTitles, (title, index) => (
                  <th
                    className='value-table value-table--table__label'
                    key={index}
                  >
                    <div className='value-table__label'> {title} </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='table__body'>
              {state.dialogStatus === DIALOG_STATUS.deleteDialogEnabled.id &&
                _.map(
                  _.unionWith(
                    state.selectedApproveCheckInOutLogList,
                    state.selectedUnapprovedCheckInOutLogList,
                    _.isEqual
                  ),
                  (inOutResult, index) => {
                    return <FixItems inOutResult={inOutResult} key={index} />;
                  }
                )}
              {state.dialogStatus === DIALOG_STATUS.approvedDialogEnabled.id &&
                _.map(
                  state.selectedUnapprovedCheckInOutLogList,
                  (inOutResult, index) => {
                    return <FixItems inOutResult={inOutResult} key={index} />;
                  }
                )}
              {state.dialogStatus ===
                DIALOG_STATUS.unapprovedDialogEnabled.id &&
                _.map(
                  state.selectedApproveCheckInOutLogList,
                  (inOutResult, index) => {
                    return <FixItems inOutResult={inOutResult} key={index} />;
                  }
                )}
            </tbody>
          </table>
        </div>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 選択中の入退場実績表示
 * */
const FixItems = ({ inOutResult }) => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {() => (
        <tr className='table__item'>
          <td className='gate-list-value-table__name'>
            <p>{inOutResult.worker_name}</p>
          </td>
          <td className='gate-list-value-table__name'>
            <p>
              {moment(new Date(inOutResult.target_date).toISOString()).format(
                DATE_TIME_FORMAT.slashDateFormat
              )}
            </p>
          </td>
          <td className='gate-list-value-table__name'>
            <p>
              {moment(
                new Date(
                  data.date.year,
                  data.date.month,
                  data.date.day,
                  Number(inOutResult.in_hour),
                  Number(inOutResult.in_min),
                  Number(inOutResult.in_sec)
                ).toISOString()
              ).format(DATE_TIME_FORMAT.timeFormat)}
            </p>
          </td>
          <td className='gate-list-value-table__name'>
            <p>
              {!isNullOrEmpty(inOutResult.out_hour) &&
                !isNullOrEmpty(inOutResult.out_min) &&
                moment(
                  new Date(
                    data.date.year,
                    data.date.month,
                    data.date.day,
                    Number(inOutResult.out_hour),
                    Number(inOutResult.out_min),
                    Number(inOutResult.out_sec)
                  ).toISOString()
                ).format(DATE_TIME_FORMAT.timeFormat)}
            </p>
          </td>
        </tr>
      )}
    </InOutResultContext.Consumer>
  );
};

// 定数
const data = {
  buttonTitle: {
    add: '新規追加',
    delete: '選択項目の削除',
    approveAll: '全承認',
    approve: '選択項目の承認',
    unapproved: '選択項目の承認解除',
    select: '選択',
    worker_search: '作業員選択',
    search: '検索',
    back: '戻る',
    close: '閉じる',
    backWorkerSelect: '←作業員一覧に戻る',
    downloadCsv: 'CSV出力',
  },
  addDialog: {
    subcontractor: '協力会社',
    companyName: '会社名',
    workerName: '入退場者名',
    workerNameSelect: '作業員選択',
    workerType: '入退場者種別',
    fieldTree: '現場体制',
    recordingMethod: '記録方法',
    attendanceDate: '出勤日',
    inTime: '入場時刻',
    outTime: '退場時刻',
    nextDay: '日跨ぎ',
    manualBodyTemperature: '体温',
    remarks: '備考',
    manualUpdateUser: '編集ユーザー',
    manualUpdateAt: '更新日時',
    jobCategory: '職種',
    position: '立場',
    workContent: '作業内容',
  },
  searchTitle: {
    companyName: '所属会社',
    workerName: '氏名（カナ検索可）',
  },
  date: {
    year: 0,
    month: 0,
    day: 0,
  },
  tableTitles: ['氏名', '出勤日', '入場時刻', '退場時刻'],
  workerSelectTableTitles: ['作業員名', '所属会社', '生年月日', 'CCUS技能者ID'],
  fieldTreeSelectTableTitles: ['所属会社', '施工体系'],
  dateColon: '：',
  placeholder: {
    attendanceDate: '（例）2020/01/01',
    jobCategory: '職種を選択',
    position: '立場を選択',
    companyName: '所属会社を選択',
    workerName: '作業員名を入力',
  },
};



// WEBPACK FOOTER //
// ./src/components/header/InOutResultOperationHeader.jsx